// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import type { UnifizeChatRoom } from "src/types";

import Icons from "src/icons";
import {
  Button,
  ModalBody,
  ModalFooter,
  VStack,
  HStack,
  CheckboxGroup,
  Checkbox,
  Text,
} from "@chakra-ui/react";
import * as colors from "src/styles/constants/colors";

import * as styles from "../styles";

type Props = {
  autoLink: boolean,
  versions: UnifizeChatRoom[],
  selectedVersions: string[],
  processTitle: string,
  onEnterEditMode: Function,
};

const Viewer = ({
  autoLink,
  versions,
  selectedVersions,
  processTitle,
  onEnterEditMode,
}: Props) => {
  return (
    <>
      <ModalBody {...styles.modalBody}>
        <VStack {...styles.radioOptions}>
          <HStack {...styles.centerAlign}>
            <Icons
              fill={autoLink ? colors.purple : colors.inkLightest}
              type="currentRevision"
            />

            <HStack {...styles.autoLinkText}>
              <Text {...styles.boldText}>
                {i18n.t(k.AUTO_SELECT_ALL_REVISIONS_IS)}
              </Text>
              <Text
                {...styles.boldText}
                color={autoLink ? "unifize_darkGreen" : "unifize_inkLightest"}
              >
                {autoLink ? i18n.t(k.ENABLED) : i18n.t(k.DISABLED)}
              </Text>
            </HStack>
          </HStack>

          <CheckboxGroup value={selectedVersions}>
            {versions.map((version) => (
              <Checkbox
                key={version.id}
                value={version.id}
                isDisabled
                {...styles.radio}
              >
                <Text {...styles.normalText}>
                  {processTitle}{" "}
                  {`${i18n.t(k._7)}${version.autoNo || version.seqNo || ""}`}
                  {version.currentVersion && "C"}
                  {i18n.t(k._)} {version.title}
                </Text>
                <Text {...styles.versionComment}>{version.versionComment}</Text>
              </Checkbox>
            ))}
          </CheckboxGroup>
        </VStack>
      </ModalBody>

      <ModalFooter {...styles.modalFooter}>
        <Button onClick={onEnterEditMode} {...styles.editButton}>
          {i18n.t(k.EDIT_SELECTED_REVISION_S)}
        </Button>
      </ModalFooter>
    </>
  );
};

export default Viewer;
